import { makeStyles } from "@mui/styles";

export const useStyles = makeStyles(({ palette, spacing }) => ({
  viewport: {
    alignItems: "flex-start",
    backgroundColor: palette.background.default,
    bottom: 0,
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
    left: spacing(8),
    position: "absolute",
    right: 0,
    top: spacing(8),
  },
  "viewport--dangerous": {
    bottom: 30,
  },
  "viewport--expanded": {
    left: spacing(32),
  },
}));
